import getLocaleParam from 'Pods/Shared/Utils/getLocaleParam'

import { searchPageStore } from '../index'

// Moderation flags can change after the action/preload caches serialize a result set, so cached
// payloads may carry a stale primaryImage.isAdultContent - a newly restricted thumbnail would stay
// unblurred and clickable until the caches refresh. Mirror legacy ListingPage.jsx's
// fetchTrackingInfo: re-read the uncached adult flags for the visible ids and patch them in place.
// The rest of the tracking_info payload (GA attributes) stays out of scope with the deferred
// analytics wiring.
export const refreshAdultFlags = async () => {
  const itemIds = searchPageStore.getState().results.map((model) => model.id).filter(Boolean)
  if (!itemIds.length) {
    return
  }

  const localeParam = getLocaleParam()
  const query = [
    `item_ids=${itemIds.join(',')}`,
    localeParam ? `locale=${localeParam}` : null,
  ].filter(Boolean).join('&')

  try {
    const trackingInfo = await window.fetchJSON(`/listing_page/tracking_info?${query}`)
    const adultFlags = trackingInfo?.adult_flags
    if (!adultFlags) {
      return
    }

    // Re-read after the await: a filter change may have replaced the set mid-flight. Patching by
    // id only touches items the response covers, so a fresher result set is never clobbered.
    const currentResults = searchPageStore.getState().results
    let changed = false
    const patchedResults = currentResults.map((model) => {
      const freshFlag = adultFlags[model.id]
      const currentFlag = !!model.attributes?.primaryImage?.isAdultContent
      if (freshFlag === undefined || freshFlag === currentFlag) {
        return model
      }
      changed = true
      return {
        ...model,
        attributes: {
          ...model.attributes,
          primaryImage: { ...model.attributes?.primaryImage, isAdultContent: freshFlag },
        },
      }
    })

    if (changed) {
      searchPageStore.setState({ results: patchedResults })
    }
  } catch (error) {
    // Best-effort: on failure the serialized flags stay, same silent fallback as ListingPage.
  }
}
